<template>
  <ul id="scayle-listbox-options" role="listbox">
    <slot />
  </ul>
</template>
